import React from 'react';
import map from '../assets/map.png';
const LocationSection = () => {
  return (
    <div className="my-20">
      <div className="max-w-6xl mx-auto px-10 my-20">
        <div className="hidden md:flex flex-col px-20  md:flex-row items-center gap-4">
          <div className="flex-1">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10426.023494915293!2d-74.07926433335636!3d40.73624596897954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c257303c0836c7%3A0xcf8130fcbbb30de4!2sShri%20Hanumanji%20Temple%2C%20Jersey%20City!5e0!3m2!1sen!2sin!4v1735752929481!5m2!1sen!2sin"
              title="Shri Hanumanji Temple, Jersey City"
              className="w-[400px] h-[300px] rounded-lg shadow-md"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div className="flex-1 text-left">
            <h2 className="text-[50px] text-[#800000] font-abhaya font-bold mb-4">
              Location and Contact
            </h2>
            <p className="font-afacad text-[26px] font-bold">
              Address : 781 Newark Ave, Jersey City, NJ 07306, United States
            </p>
            <p className="font-afacad text-[26px] font-bold">
              Contact : +1(201)-659-8250
            </p>
          </div>
        </div>

        <div className="md:hidden text-center">
          <h2 className="text-[50px] text-[#800000] font-abhaya font-bold mb-4">
            Location and Address
          </h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10426.023494915293!2d-74.07926433335636!3d40.73624596897954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c257303c0836c7%3A0xcf8130fcbbb30de4!2sShri%20Hanumanji%20Temple%2C%20Jersey%20City!5e0!3m2!1sen!2sin!4v1735752929481!5m2!1sen!2sin"
            title="Shri Hanumanji Temple, Jersey City"
            className="w-[350px] h-[300px] rounded-lg shadow-md"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="flex flex-col items-start mt-[30px]">
            <p className="font-afacad text-[26px] font-bold">
              Address : 781 Newark Ave, Jersey City, NJ 07306, United States
            </p>
            <p className="font-afacad text-[26px] font-bold">
              Contact : +1(201)-659-8250
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSection;
